export enum HBOStatus {
  ACTIVE = 'ACTIVE',
  IN_REGISTRATION = 'IN_REGISTRATION',
  NOT_ACTIVE = 'NOT_ACTIVE',
  NOT_ALLOWED = 'NOT_ALLOWED',
}
